import React, { useState, useEffect } from "react";
import { T } from "./theme";
import { Input, Btn, Modal } from "./ui";
import { Icon } from "./Icons";
import { supabase } from "./supabase";

// Busca endereço pelo CEP (ViaCEP, grátis, sem chave)
export async function buscarEnderecoPorCep(cep) {
  const c = (cep || "").replace(/\D/g, "");
  if (c.length !== 8) return null;
  try {
    const r = await fetch(`https://viacep.com.br/ws/${c}/json/`);
    const d = await r.json();
    if (d.erro) return null;
    return { endereco: d.logradouro || "", bairro: d.bairro || "", cidade: d.localidade || "", estado: d.uf || "" };
  } catch { return null; }
}

const up = v => (v == null ? v : String(v).toUpperCase());

// Seletor de cliente existente (busca por nome/CPF/CNPJ) + "Adicionar novo cliente"
// corretorId: se informado, mostra só os clientes daquele corretor (escopo do plantão).
export function ClienteSelector({ corretorId, onSelect }) {
  const [clientes, setClientes] = useState([]);
  const [busca, setBusca] = useState("");
  const [aberto, setAberto] = useState(false);
  const [novo, setNovo] = useState(false);
  const [loading, setLoading] = useState(false);

  async function carregar() {
    setLoading(true);
    try {
      let q = supabase.from("clientes").select("*").order("nome");
      if (corretorId) q = q.eq("corretor_id", corretorId);
      const { data } = await q.limit(1000);
      setClientes(data || []);
    } catch (_) { /* silencioso */ }
    finally { setLoading(false); }
  }
  useEffect(() => { carregar(); }, [corretorId]);

  async function excluirCliente(cli, e) {
    e.stopPropagation();
    if (!window.confirm(`Excluir o cliente "${[cli.nome, cli.sobrenome].filter(Boolean).join(" ")}"? Isso também remove o contato no Wix.`)) return;
    try {
      // Apaga no Wix primeiro (se tiver vínculo)
      if (cli.wix_contact_id) {
        try { await fetch("/api/wix-delete-contact", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ wix_contact_id: cli.wix_contact_id }) }); } catch (_) {}
      }
      const { error } = await supabase.from("clientes").delete().eq("id", cli.id);
      if (error) throw error;
      setClientes(prev => prev.filter(x => x.id !== cli.id));
    } catch (err) { alert("Erro ao excluir: " + err.message); }
  }

  const q = busca.trim().toLowerCase();
  const qNum = q.replace(/\D/g, "");
  const filtrados = (q
    ? clientes.filter(c => {
        const nome = [c.nome, c.sobrenome].filter(Boolean).join(" ").toLowerCase();
        const doc = (c.cpf_cnpj || "").toLowerCase();
        return nome.includes(q) || doc.includes(q) || (qNum && doc.replace(/\D/g, "").includes(qNum));
      })
    : clientes).slice(0, 30);

  return (
    <div style={{ position: "relative" }}>
      <div style={{ fontSize: 10, color: T.textSub, marginBottom: 4, fontWeight: 600, letterSpacing: 0.5 }}>Cliente</div>
      <input
        value={busca}
        onChange={e => { setBusca(e.target.value); setAberto(true); }}
        onFocus={() => setAberto(true)}
        placeholder="Buscar por nome, CPF ou CNPJ…"
        style={{ width: "100%", fontSize: 13, padding: "10px 12px", boxSizing: "border-box", background: T.input, border: `1px solid ${T.border}`, borderRadius: T.r.md, color: T.text }}
      />
      {aberto && (
        <>
          <div onClick={() => setAberto(false)} style={{ position: "fixed", inset: 0, zIndex: 15 }} />
          <div style={{ position: "absolute", zIndex: 20, left: 0, right: 0, marginTop: 4, background: T.card, border: `1px solid ${T.border}`, borderRadius: T.r.md, maxHeight: 280, overflowY: "auto", boxShadow: "0 8px 24px rgba(0,0,0,0.35)" }}>
            {loading && <div style={{ padding: 12, fontSize: 12, color: T.textDim }}>Carregando…</div>}
            {!loading && filtrados.length === 0 && <div style={{ padding: 12, fontSize: 12, color: T.textDim }}>Nenhum cliente encontrado. Adicione um novo abaixo.</div>}
            {filtrados.map(c => (
              <div key={c.id} style={{ display: "flex", alignItems: "center", borderBottom: `1px solid ${T.border}` }}>
                <button onClick={() => { onSelect(c); setBusca([c.nome, c.sobrenome].filter(Boolean).join(" ")); setAberto(false); }}
                  style={{ flex: 1, minWidth: 0, textAlign: "left", background: "none", border: "none", padding: "10px 12px", cursor: "pointer", color: T.text, fontFamily: "inherit" }}>
                  <div style={{ fontSize: 13, fontWeight: 600 }}>{[c.nome, c.sobrenome].filter(Boolean).join(" ") || "—"}</div>
                  <div style={{ fontSize: 11, color: T.textSub }}>{[c.cpf_cnpj, (c.cidade && `${c.cidade}-${c.estado || ""}`), (c.whatsapp || c.telefone)].filter(Boolean).join(" · ")}</div>
                </button>
                <button onClick={(e) => excluirCliente(c, e)} title="Excluir cliente (app + Wix)"
                  style={{ background: "none", border: "none", color: T.textDim, cursor: "pointer", fontSize: 13, padding: "0 12px", fontFamily: "inherit" }}>🗑️</button>
              </div>
            ))}
            <button onClick={() => { setNovo(true); setAberto(false); }}
              style={{ display: "flex", alignItems: "center", gap: 6, width: "100%", textAlign: "left", background: T.brandSoft, border: "none", padding: "11px 12px", cursor: "pointer", color: T.brand, fontFamily: "inherit", fontWeight: 600, fontSize: 12 }}>
              <Icon.plus size={13} /> Adicionar novo cliente
            </button>
          </div>
        </>
      )}
      {novo && (
        <ModalNovoCliente
          corretorId={corretorId}
          onSalvar={(c) => { setNovo(false); setClientes(prev => [c, ...prev]); onSelect(c); setBusca([c.nome, c.sobrenome].filter(Boolean).join(" ")); }}
          onCancelar={() => setNovo(false)}
        />
      )}
    </div>
  );
}

// Campos obrigatórios do cliente
const CLIENTE_OBRIGATORIOS = [
  ["nome", "Nome"], ["sobrenome", "Sobrenome"], ["cpf_cnpj", "CPF/CNPJ"], ["email", "E-mail"],
  ["cep", "CEP"], ["endereco", "Endereço"], ["cidade", "Cidade"], ["estado", "Estado"],
];
export function faltamCamposCliente(p) {
  p = p || {};
  const faltam = CLIENTE_OBRIGATORIOS.filter(([k]) => !String(p[k] || "").trim()).map(([, lbl]) => lbl);
  if (!String(p.whatsapp || "").trim() && !String(p.telefone || "").trim()) faltam.push("WhatsApp/Telefone");
  return faltam;
}

// Formulário separado de cliente (novo OU completar cadastro; CEP → endereço automático)
export function ModalNovoCliente({ corretorId, onSalvar, onCancelar, inicial, clienteId, titulo }) {
  const [c, setC] = useState({
    nome: inicial?.nome || "", sobrenome: inicial?.sobrenome || "", cpf_cnpj: inicial?.cpf_cnpj || "",
    email: inicial?.email || "", telefone: inicial?.telefone || "", whatsapp: inicial?.whatsapp || "",
    cep: inicial?.cep || "", endereco: inicial?.endereco || "", numero: inicial?.numero || "",
    bairro: inicial?.bairro || "", cidade: inicial?.cidade || "", estado: inicial?.estado || "",
    ponto_referencia: inicial?.ponto_referencia || "",
  });
  const [salvando, setSalvando] = useState(false);
  const set = (k, v) => setC(p => ({ ...p, [k]: v }));
  const setUpper = (k, v) => set(k, up(v));

  async function onCep(v) {
    set("cep", v);
    const info = await buscarEnderecoPorCep(v);
    if (info) setC(p => ({
      ...p,
      endereco: up(info.endereco) || p.endereco,
      bairro: up(info.bairro) || p.bairro,
      cidade: up(info.cidade) || p.cidade,
      estado: up(info.estado) || p.estado,
    }));
  }

  async function salvar() {
    const faltam = faltamCamposCliente(c);
    if (faltam.length) { alert("Preencha os campos obrigatórios do cliente:\n\n" + faltam.join(", ")); return; }
    setSalvando(true);
    try {
      const row = {
        nome: up(c.nome), sobrenome: up(c.sobrenome), cpf_cnpj: c.cpf_cnpj || null,
        email: c.email ? c.email.trim().toLowerCase() : null,
        telefone: c.telefone || null, whatsapp: c.whatsapp || null,
        cep: c.cep || null, endereco: up(c.endereco), numero: c.numero || null,
        bairro: up(c.bairro), cidade: up(c.cidade), estado: up(c.estado),
        ponto_referencia: up(c.ponto_referencia),
      };
      if (clienteId) {
        // Completar/editar cadastro existente
        const { data, error } = await supabase.from("clientes").update(row).eq("id", clienteId).select().single();
        if (error) throw error;
        onSalvar(data);
      } else {
        // Novo → cria contato no Wix + salva local
        let wixId = null;
        try {
          const r = await fetch("/api/wix-create-contact", {
            method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ nome: up(c.nome), sobrenome: up(c.sobrenome), email: c.email, telefone: c.telefone, whatsapp: c.whatsapp, cep: c.cep, endereco: up(c.endereco), cidade: up(c.cidade), estado: up(c.estado) }),
          });
          const w = await r.json();
          if (w && w.ok) wixId = w.wix_contact_id || null;
        } catch (_) { /* se o Wix falhar, salva local mesmo assim */ }
        const { data, error } = await supabase.from("clientes").insert({ ...row, wix_contact_id: wixId, corretor_id: corretorId || null, origem: "manual" }).select().single();
        if (error) throw error;
        onSalvar(data);
      }
    } catch (e) { alert("Erro ao salvar cliente: " + e.message); }
    finally { setSalvando(false); }
  }

  return (
    <Modal title={titulo || "Novo cliente"} onClose={onCancelar} width={560}>
      <style>{`.cli-caps input:not([type="email"]) { text-transform: uppercase; } .cli-caps label { text-transform: none !important; }`}</style>
      <div className="cli-caps" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
        <Input label="Nome" value={c.nome} onChange={e => setUpper("nome", e.target.value)} />
        <Input label="Sobrenome" value={c.sobrenome} onChange={e => setUpper("sobrenome", e.target.value)} />
        <Input label="CPF / CNPJ" value={c.cpf_cnpj} onChange={e => set("cpf_cnpj", e.target.value)} />
        <Input label="E-mail" type="email" value={c.email} onChange={e => set("email", e.target.value)} />
        <Input label="Telefone" value={c.telefone} onChange={e => set("telefone", e.target.value)} />
        <Input label="WhatsApp" value={c.whatsapp} onChange={e => set("whatsapp", e.target.value)} />
        <Input label="CEP" value={c.cep} onChange={e => onCep(e.target.value)} placeholder="Só números" />
        <Input label="Número" value={c.numero} onChange={e => set("numero", e.target.value)} />
        <Input label="Endereço" value={c.endereco} onChange={e => setUpper("endereco", e.target.value)} />
        <Input label="Bairro" value={c.bairro} onChange={e => setUpper("bairro", e.target.value)} />
        <Input label="Cidade" value={c.cidade} onChange={e => setUpper("cidade", e.target.value)} />
        <Input label="Estado (UF)" value={c.estado} onChange={e => setUpper("estado", e.target.value)} />
        <div style={{ gridColumn: "1 / -1" }}>
          <Input label="Ponto de referência" value={c.ponto_referencia} onChange={e => setUpper("ponto_referencia", e.target.value)} />
        </div>
      </div>
      <div style={{ fontSize: 10, color: T.textDim, marginTop: 6 }}>Digite o CEP pra puxar o endereço automaticamente.</div>
      <div style={{ marginTop: 14, display: "flex", justifyContent: "flex-end", gap: 8, borderTop: `1px solid ${T.border}`, paddingTop: 12 }}>
        <Btn variant="ghost" onClick={onCancelar}>Cancelar</Btn>
        <Btn onClick={salvar} disabled={salvando} icon={<Icon.check size={14} />}>{salvando ? "Salvando…" : "Salvar cliente"}</Btn>
      </div>
    </Modal>
  );
}
